import { TransformInitOptions } from '../../../../middleware';
import { AppState } from '../../../app.types';
import { addAuthHeaders } from './add-auth-headers';
import { addLocaleHeader } from './add-locale-header';

/**
 * This is a form of middleware to add the required application http headers
 * to the fetch requests. It occurs pre every request and can mutate anything on the standard
 * fetch init: RequestInit object given to the request.
 *
 * @see https://bitbucket.org/mathletics/3p-portal/src/3f7324219479dd2b1091943c2143ead1d3ba4a74/common/interceptors/http-request-interceptor.js#lines-13
 */
export function transformAppInit (options: TransformInitOptions<AppState>) {
    return {
        ...options.init,
        headers: {
            ...options.init.headers,
            ...addAuthHeaders(options),
            ...addLocaleHeader(options)
        }
    };
}
